type SaveFilePickerOptions = {
  suggestedName?: string;
  types?: Array<{
    description?: string;
    accept: Record<string, string[]>;
  }>;
};

type SaveFilePickerWindow = Window & {
  // eslint-disable-next-line no-unused-vars
  showSaveFilePicker: (options?: SaveFilePickerOptions) => Promise<FileSystemFileHandle>;
};

function getSaveFilePickerWindow(): SaveFilePickerWindow | null {
  if (typeof window === 'undefined' || !('showSaveFilePicker' in window)) {
    return null;
  }
  return window as SaveFilePickerWindow;
}

export function supportsFileSystemAccess(): boolean {
  return getSaveFilePickerWindow() !== null;
}

export async function promptSaveFileHandle(zipName: string): Promise<FileSystemFileHandle | null> {
  const pickerWindow = getSaveFilePickerWindow();
  if (!pickerWindow) {
    return null;
  }

  try {
    return await pickerWindow.showSaveFilePicker({
      suggestedName: `${zipName}.zip`,
      types: [
        {
          description: 'ZIP',
          accept: { 'application/zip': ['.zip'] },
        },
      ],
    });
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      return null;
    }
    return null;
  }
}

export async function promptSaveExcelFileHandle(
  fileName: string,
): Promise<FileSystemFileHandle | null> {
  const pickerWindow = getSaveFilePickerWindow();
  if (!pickerWindow) {
    return null;
  }

  const suggestedName = fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;

  try {
    return await pickerWindow.showSaveFilePicker({
      suggestedName,
      types: [
        {
          description: 'Excel',
          accept: {
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
          },
        },
      ],
    });
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      throw error;
    }
    return null;
  }
}
